<template>
    <app-wrapper :color="wrapperColor">
        <app-header></app-header>
        <app-body :bodyClass="bodyClass">
            <slot />
        </app-body>
        <lazy-app-footer v-if="showFooter" :color="footerColor"></lazy-app-footer>
    </app-wrapper>
</template>

<script setup>
const route = useRoute();

const darkRoutes = [
    'index',
    'dancers-dancerSlug',
    'events',
    'events-eventSlug',
    'live',
    'live-streamSlug',
    'videos',
    'videos-idVideo',
];

const wrapperColor = computed(() => {
    if (route.name === 'search') return 'bg-zinc-100';
    if (darkRoutes.includes(route.name)) return 'bg-black';
    return 'bg-transparent';
});

const bodyClass = computed(() => {
    if (route.name === 'classes') return 'h-full';
    if (['login', 'login-code', 'login-index-passcode'].includes(route.name)) return 'h-screen';
    return 'mb-auto';
});

const footerColor = computed(() => {
    if (darkRoutes.includes(route.name)) return 'bg-black';
    return 'bg-zinc-900';
});

const showFooter = computed(() => {
    return ![
        'search',
        'classes',
        'videos-idVideo',
        'login',
        'login-code',
        'login-index-passcode',
        'messages',
        'messages-index-idThread',
        'messages-index-idThread-token',
    ].includes(route.name);
});
</script>
